export enum DriveError {
  existingFolder = "Directory already present",
  noAccess = "No access",
  limitReached = "max_limit_reached",
}
